<template>
  <div class="container">
    <div class="content-bg">
      <div class="inline-wrapper ranking-date">
        <div class="date-left-r">
          <div style="display: flex;align-items: center;">
            <el-form
              inline
              size="mini"
              class="table-search-part more-search-part inline-wrapper"
              @submit.native.prevent="handleQuery()"
            >
              <div>
                <el-form-item label="Channel Type" style="margin-right: 10px;">
                  <el-select v-model="ChannelType" filterable @change="agentChange">
                    <el-option
                      v-for="item in agentList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Merchant Level 1" style="margin-right: 10px;">
                  <el-select
                    v-model="partner"
                    filterable
                    placeholder="select"
                    @change="partnerChange"
                    clearable
                  >
                    <el-option
                      v-for="item in partnerSelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Merchant Level 2" style="margin-right: 10px;">
                  <el-select
                    v-model="masterDistributor"
                    filterable
                    placeholder="select"
                    @change="masterDistributorChange"
                    clearable
                  >
                    <el-option
                      v-for="item in masterDistributorSelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Merchant Level 3" style="margin-right: 10px;">
                  <el-select
                    @change="distributorChange"
                    v-model="distributor"
                    filterable
                    placeholder="select"
                    clearable
                  >
                    <el-option
                      v-for="item  in distributorSelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Merchant Level 4" style="margin-right: 10px;">
                  <el-select
                    v-model="company"
                    @change="companyChange"
                    filterable
                    placeholder="select"
                    clearable
                  >
                    <el-option
                      v-for="item in companySelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="Channel" style="margin-right: 10px;">
                  <el-select
                    v-model="queryData.merchantId"
                    placeholder="Channel"
                    filterable
                    clearable
                    @change="merchantIdChange"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in merchatList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Channel ID" style="margin-right: 10px;">
                  <el-input v-model="queryData.merchantId" clearable placeholder="input"></el-input>
                </el-form-item>
                <el-form-item
                  label="Channel Template"
                  class="level-box"
                  style="margin-right: 10px;"
                >
                  <el-select
                    v-model="queryData.templateId"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="Channel Template"
                  >
                    <el-option
                      v-for="item in levelListName"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="Bonus Template"
                  class="level-box"
                  style="margin-right: 10px;"
                >
                  <el-select
                    v-model="queryData.promotionTemplateId"
                    filterable
                    clearable
                    placeholder="Bonus Template"
                  >
                    <el-option
                      v-for="item in bonusListName"
                      :key="item.id"
                      :label="item.templateName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="Warning Template"
                  class="level-box"
                  style="margin-right: 10px;"
                >
                  <el-select
                    v-model="queryData.warningTemplateId"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="Warning Template"
                  >
                    <el-option
                      v-for="item in warningListName"
                      :key="item.id"
                      :label="item.templateName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Odds Level" style="margin-right: 10px;">
                  <el-select
                    v-model="queryData.oddsLevelId"
                    filterable
                    clearable
                    placeholder="Odds Level"
                  >
                    <el-option
                      v-for="item in oddList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Odds Level(New User)" style="margin-right: 10px;">
                  <el-select
                    v-model="queryData.newUserOddsLevelId"
                    filterable
                    clearable
                    placeholder="Odds Level(New User)"
                  >
                    <el-option
                      v-for="item in oddList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Margin Odds Level" style="margin-right: 10px;">
                  <el-select
                    v-model="queryData.marginOddsLevelId"
                    filterable
                    clearable
                    placeholder="Margin Odds Level"
                  >
                    <el-option
                      v-for="item in oddList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Margin Odds Level(New User)" style="margin-right: 10px;">
                  <el-select
                    v-model="queryData.newUserMarginOddsLevelId"
                    filterable
                    clearable
                    placeholder="Margin Odds Level(New User)"
                  >
                    <el-option
                      v-for="item in oddList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-button class="search-btn" :loading="loading" @click="handleQuery()">Search</el-button>
                  <!-- <el-button class="clear-btn" @click="handleClear()">Clear</el-button> -->
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div class="middle-btn inline-wrapper">
        <div class="middle-left">
          <el-button class="lebel-risk-export-btn" @click="isShow('Batch Modify')">Batch Modify</el-button>
        </div>
      </div>
      <div class="ranking-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          v-loading="loadingList"
          @selection-change="handleSelectionChange"
          header-row-class-name="table-header-row"
          border
          stripe
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column type="selection" align="center" width="36"></el-table-column>
          <el-table-column label="Channel ID" min-width="180">
            <template v-slot="{row}">
              <div>{{ row.merchantId }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Channel" min-width="160">
            <template v-slot="{row}">
              <div
                :style="{color:row.merchantFontColor,background: row.merchantBgColor,padding: '10px 2px',borderRadius: '4px'}"
              >{{row.merchantName}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Channel Template"
            min-width="140"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="{row}">
              <div>{{row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Bonus Template"
            min-width="140"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="{row}">
              <div>{{row.promotionTemplateName}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Warning Template"
            min-width="140"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="{row}">
              <div>{{row.warningTemplateName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Odds Level" min-width="100" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <div>{{feachOddsLevel(row.oddsLevelId)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Odds Level(New User)" min-width="150" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <div>{{feachOddsLevel(row.newUserOddsLevelId)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Margin Odds Level" min-width="140" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <div>{{feachOddsLevel(row.marginOddsLevelId)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Margin Odds Level(New User)" min-width="200" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <div>{{feachOddsLevel(row.newUserMarginOddsLevelId)}}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Warning %" prop="levelName" align="center" min-width="80">
            <template v-slot="{row}">
              <div>{{+(row.warning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Warning Loss Per Day" align="center" min-width="150">
            <template v-slot="{row}">
              <div>{{row.warningLossPerDay}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Warning Loss Per Match"
            prop="warningLossPerMatch"
            min-width="170"
            align="right"
          ></el-table-column>-->
          <el-table-column label="Stake Factor" prop="levelId" min-width="110" align="center">
            <template v-slot="{row}">
              <div>{{fetchLevel(row.levelId,1)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Stake Factor(New User)" min-width="160px" align="center">
            <template v-slot="{row}">
              <div>{{fetchLevel(row.newUserLevelId,2)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Default Single Bet Setting" min-width="100">
            <template v-slot="{ row }">
              <el-switch
                v-model="row.defaultSingleBetSetting"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="handleSingleBet(row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="Minimum Stake Factor" min-width="150px" align="left">
            <template v-slot="{row}">
              <div style="text-align: center;">{{row.minStakeFactor}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Remark" prop="remark" min-width="200" align="right">
            <template v-slot="{row}">
              <div>{{ row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Update Time" prop="bets" min-width="170" align="right">
            <template v-slot="{row}">
              <div v-if="row.updateTime">{{ formatUtc(row.updateTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Operation" min-width="400" align="center">
            <template v-slot="{row}">
              <div>
                <el-button class="table-inner-btn" @click="handleViewEidt(1,row,'Modify')">Modify</el-button>
                <el-button
                  class="table-inner-btn"
                  @click="handleViewEidt(2,row,'Channel History')"
                >History</el-button>
                <el-button
                  class="table-inner-btn config-btn"
                  @click="handleViewConfig(row)"
                >Tournament Config</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="total"
          :current-page="queryData.current"
          :page-size="queryData.size"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <dia ref="dialogListDom" :class="['label-dialog']">
      <!-- history4 -->
      <div v-if="histroyNum == 2">
        <el-table
          :data="historyRows"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty"><Empty/></template>

          <el-table-column label="Time" min-width="160">
            <template v-slot="{row}">
              {{ formatUtc(row.time) }}
            </template>
          </el-table-column>

          <!-- 关键：根据顺序与 map 渲染六列 -->
          <el-table-column
            v-for="key in historyFieldOrder"
            :key="key"
            :label="historyFieldMap[key]"
            min-width="200"
            show-overflow-tooltip
          >
            <template v-slot="{row}">
              <span>{{ row[key] || '' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Remark" min-width="140">
            <template v-slot="{row}">
              {{ row.remark || '' }}
            </template>
          </el-table-column>
          <el-table-column label="Modifier" min-width="140">
            <template v-slot="{row}">
              {{ row.operatorName || '' }}
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryHistoryData.current"
            :page-size="queryHistoryData.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          />
        </div>

        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="CloseHistory()">Cancel</el-button>
        </div>
      </div>

      <!-- 单个修改-->
      <div v-if="histroyNum == 1" class="select-down-wrapper">
        <el-form label-width="180px">
          <el-form-item label="Channel">
            <el-input disabled v-model="queryForm.merchantName" placeholder="input"></el-input>
          </el-form-item>
          <el-form-item label="Channel Template">
            <el-select
              v-model="queryForm.templateId"
              placeholder="Channel Template"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in levelListName"
                :key="item.id"
                :label="item.name"
                :value="String(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bonus Template">
            <el-select
              v-model="queryForm.promotionTemplateId"
              placeholder="Bonus Template"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in bonusListName"
                :key="item.id"
                :label="item.templateName"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Warning Template">
            <el-select
              v-model="queryForm.warningTemplateId"
              placeholder="Warning Template"
              :popper-append-to-body="false"
              disabled
            >
              <el-option
                v-for="item in warningListName"
                :key="item.id"
                :label="item.templateName"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Odds Level">
            <el-select
              v-model="queryForm.oddsLevelId"
              placeholder="Odds Level"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Odds Level(New User)">
            <el-select
              v-model="queryForm.newUserOddsLevelId"
              clearable
              placeholder="Odds Level(New User)"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevel"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Margin Odds Level">
            <el-select
              v-model="queryForm.marginOddsLevelId"
              placeholder="Margin Odds Level"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevel"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Margin Odds Level(New User)">
            <el-select
              v-model="queryForm.newUserMarginOddsLevelId"
              clearable
              placeholder="Margin Odds Level(New User)"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevel"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Remark">
            <el-input v-model="queryForm.remark" clearable placeholder="input"></el-input>
          </el-form-item>
          <el-form-item label="bgColor">
            <el-color-picker v-model="queryForm.bgColor"></el-color-picker>
          </el-form-item>
          <el-form-item label="fontColor">
            <el-color-picker v-model="queryForm.fontColor"></el-color-picker>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleBatchModify(1)">Confirm</el-button>
          <el-button class="clear-btn" @click="singleClose()">Cancel</el-button>
        </div>
      </div>
    </dia>
    <dia ref="dialogDom" :class="['label-dialog']">
      <!-- 批量修改-->
      <div class="select-down-wrapper">
        <el-form label-width="180px">
          <el-form-item label="Channel Template">
            <el-select
              v-model="levelQueryData.templateId"
              placeholder="Channel Template"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in levelListName"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bonus Template">
            <el-select
              v-model="levelQueryData.promotionTemplateId"
              placeholder="Bonus Template"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in bonusListName"
                :key="item.id"
                :label="item.templateName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Odds Level">
            <el-select
              v-model="levelQueryData.oddsLevelId"
              placeholder="Odds Level"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Odds Level(New User)">
            <el-select
              v-model="levelQueryData.newUserOddsLevelId"
              clearable
              placeholder="Odds Level(New User)"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevel"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Margin Odds Level">
            <el-select
              v-model="levelQueryData.marginOddsLevelId"
              placeholder="Margin Odds Level"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevel"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Margin Odds Level(New User)">
            <el-select
              v-model="levelQueryData.newUserMarginOddsLevelId"
              clearable
              placeholder="Margin Odds Level(New User)"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in oddsLevel"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Remark">
            <el-input v-model="levelQueryData.remark" clearable placeholder="input"></el-input>
          </el-form-item>
          <el-form-item label="bgColor">
            <el-color-picker v-model="levelQueryData.bgColor"></el-color-picker>
          </el-form-item>
          <el-form-item label="fontColor">
            <el-color-picker v-model="levelQueryData.fontColor"></el-color-picker>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleBatchModify(2)">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import { getRiskLevel, getMerchat, queryAgentNames } from "@/api/member";
import {
  getChannelList,
  getTemplateList,
  getMerchantHistoryList,
  updateMerchantTemplate,
  getWarningTemplateList,
  getPromotionTemplateList,
} from "@/api/channel";
export default {
  name: "RankingList",
  data() {
    return {
      totalAert: 0,
      loadingItem: false,
      historyList: [],

      partnerSelect: [], // 合伙商列表
      masterDistributorSelect: [], // 总经销列表
      distributorSelect: [], // 经销商
      companySelect: [], // 公司
      ChannelType: 1,
      partner: "",
      masterDistributor: "",
      distributor: "",
      company: "",
      histroyNum: "",
      queryAgent: {
        level: "",
        parentId: ""
      },
      agentList: [
        { id: 1, val: false, name: "All" },
        { id: 2, val: true, name: "Directly Channel" }
      ],
      merchantParserData: {},

      list: [],
      levelList: [],
      levelListName: [],
      bonusListName: [],
      warningListName: [],
      merchatList: [],
      loading: false,
      loadingList: false,
      multipleSelection: [],
      queryHistoryData: {
        businessId: "",
        current: 1,
        size: 50,
        businessFields:["template_id", "promotion_template_id", "warning_template_id","odds_level_id","new_user_odds_level_id","margin_odds_level_id","new_user_margin_odds_level_id"]
      },
      // 映射：接口字段名 -> 表头展示名
      historyFieldMap: {
        template_id: 'Channel Template',
        promotion_template_id: 'Bonus Template',
        warning_template_id: 'Warning Template',
        odds_level_id: 'Odds Level',
        new_user_odds_level_id: 'Odds Level(New User)',
        margin_odds_level_id: 'Margin Odds Level',
        new_user_margin_odds_level_id: 'Margin Odds Level(New User)',
      },
      // 展示顺序（按你想要的列顺序来）
      historyFieldOrder: [
        'template_id',
        'promotion_template_id',
        'warning_template_id',
        'odds_level_id',
        'new_user_odds_level_id',
        'margin_odds_level_id',
        'new_user_margin_odds_level_id',
      ],
      historyRows: [], 
      queryData: {
        current: 1,
        size: 50,
        templateId: "",
        promotionTemplateId: "",
        merchantId: null,
        oddsLevelId: "",
        newUserOddsLevelId: "",
        marginOddsLevelId: "",
        newUserMarginOddsLevelId: "",
        warningTemplateId: ""
      },
      queryForm: {
        merchantId: [],
        oddsLevelId: "",
        newUserOddsLevelId: "",
        marginOddsLevelId: "",
        newUserMarginOddsLevelId: "",
        merchantName: "",
        templateId: "",
        warningTemplateId: "",
        remark: "",
        bgColor: "",
        promotionTemplateId: "",
        fontColor: ""
      },
      levelQueryData: {
        merchantId: [],
        templateId: "",
        promotionTemplateId: "",
        oddsLevelId: "",
        newUserOddsLevelId: "",
        marginOddsLevelId: "",
        newUserMarginOddsLevelId: "",
        remark: "",
        bgColor: "",
        fontColor: ""
      },
      oddList: [
        { id: 1, label: "A" },
        { id: 2, label: "B" },
        { id: 3, label: "C" },
        { id: 4, label: "D" },
        { id: 5, label: "E" },
        { id: 6, label: "F" },
        { id: 7, label: "G" }
      ],
      oddsLevel: [
        { id: null, label: "Config" },
        { id: 1, label: "A" },
        { id: 2, label: "B" },
        { id: 3, label: "C" },
        { id: 4, label: "D" },
        { id: 5, label: "E" },
        { id: 6, label: "F" },
        { id: 7, label: "G" }
      ],
      title: "Batch Modify",
      total: 0,
      tableHeight: window.innerHeight
    };
  },
  methods: {
    resetBatchForm() {
      this.levelQueryData = {
        merchantId: [],
        templateId: "",
        promotionTemplateId: "",
        oddsLevelId: "",
        newUserOddsLevelId: "",
        marginOddsLevelId: "",
        newUserMarginOddsLevelId: "",
        remark: "",
        bgColor: "",
        fontColor: ""
      };
    },
    // 取 afnm 优先，否则回退 v；都没有则空
    pickFieldValue(field) {
      if (!field) return '';
      // 注意：afnm 可能是空字符串，这里用 ?? 保留空串
      return (field.afnm ?? field.v ?? '') || '';
    },

    // 把后端 records 转成表格可直接渲染的行
    normalizeHistory(records) {
      const rows = [];
      (records || []).forEach(rec => {
        const fields = (rec.content && rec.content.fields) || [];
        const row = {
          time: rec.time,
          operatorName: rec.operatorName || '',
        };
        this.historyFieldOrder.forEach(key => {
          const f = fields.find(x => x.nm === key);
          row[key] = this.pickFieldValue(f);
        });
        rows.push(row);
      });
      return rows;
    },
    handleSingleBet(row) {
      let switchStr = `Switch to Default Single Bet Setting ${
        Number(row.defaultSingleBetSetting) ? "YES" : "NO"
      }？`;
      this.$confirm(switchStr, {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(async () => {
          const res = await updateMerchantTemplate({merchantId: [row.merchantId], defaultSingleBetSetting: row.defaultSingleBetSetting});
          this.$message({ message: "update success", type: "success" });
          this.getList();
        })
        .catch(() => {
          row.defaultSingleBetSetting = !row.defaultSingleBetSetting
        });
    },
    async getLevelListName() {
      this.loading = true;
      const res = await getTemplateList(this.queryData);
      this.levelListName = res.data || [];
      this.loading = false;
    },
    async getBonusListName() {
      const res = await getPromotionTemplateList({ current: 1, size: 999 });
      this.bonusListName = res.data || [];
    },
    async getWarningListName() {
      const res = await getWarningTemplateList({ current: 1, size: 100 });
      this.warningListName = res.data || [];
    },
    async getList() {
      this.loadingList = true;
      // 默认为空
      this.queryData.parentId = "";
      this.queryData.ancestorId = "";

      if (this.ChannelType == 2) {
        if (this.company) {
          this.queryData.parentId = this.company;
        } else if (this.distributor) {
          this.queryData.parentId = this.distributor;
        } else if (this.masterDistributor) {
          this.queryData.parentId = this.masterDistributor;
        } else if (this.partner) {
          this.queryData.parentId = this.partner;
        } else {
          this.$message({
            message: "Merchants must be selected for direct channels",
            type: "warning"
          });
        }
      } else {
        if (this.company) {
          this.queryData.ancestorId = this.company;
        } else if (this.distributor) {
          this.queryData.ancestorId = this.distributor;
        } else if (this.masterDistributor) {
          this.queryData.ancestorId = this.masterDistributor;
        } else if (this.partner) {
          this.queryData.ancestorId = this.partner;
        }
      }
      const res = await getChannelList(this.queryData);
      const data = res.data || {};
      this.list = data.records || [];
      this.total = data.total;
      this.loadingList = false;
    },
    fetchLevel(val, num) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
        if (num === 1) {
          if (!val) {
            name = "Default 100%";
          }
        }
      });
      return name;
    },
    feachOddsLevel(val) {
      let name = "";
      this.oddList.map(item => {
        if (item.id == val) {
          name = item.label;
        }
      });
      return name;
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 查看配置
    handleViewConfig(data) {
      this.$router.push({
        path: "/channel/config",
        query: { merchantId: data.merchantId }
      });
    },
    // merchant下拉框
    async fetchMerchantList() {
      let paramData = {};
      const res = await getMerchat(paramData);
      let data = res.data || {};

      this.merchantParserData = this.parserMerchantSelectedHttpResponse(res);
      this.merchatList = this.objToArray(this.merchantParserData.channels);
      this.partnerSelect = this.objToArray(this.merchantParserData.level1);
      this.masterDistributorSelect = this.objToArray(
        this.merchantParserData.level2
      );
      this.distributorSelect = this.objToArray(this.merchantParserData.level3);
      this.companySelect = this.objToArray(this.merchantParserData.level4);
    },
    //最新改为前端处理
    objToArray(obj) {
      if (Array.isArray(obj)) {
        return obj;
      }
      let arr = [];
      for (let key in obj) {
        let objIten = {
          id: key,
          name: obj[key].name
        };
        arr.push(objIten);
      }
      return arr;
    },
    queryLevelFromArray(localMerchantData, agents, level) {
      for (const agent of agents) {
        // 如果本地没有 agent 数据, 初始化本地数据
        if (!localMerchantData[`level${agent.level}`][agent.id]) {
          localMerchantData[`level${agent.level}`][agent.id] = {
            name: agent.name,
            childs: {},
            channels: {},
            directlyChannels: {}
          };
        }
        if (agent.level == level) {
          return {
            id: agent.id,
            name: agent.name
          };
        }
      }
      return null;
    },

    setChildAgent(localMerchantData, level, parent, child) {
      let parentLevel = localMerchantData[`level${level}`];
      let childLevel = localMerchantData[`level${level + 1}`];
      if (!parent || !child) {
        return;
      }
      parentLevel[parent.id].childs[child.id] = child.name;
      childLevel[child.id].parentId = parent.id;
    },

    setAgentChannel(agentLevel, agent, channel) {
      if (!agent || !agentLevel[[agent.id]]) {
        return;
      }
      agentLevel[agent.id].channels[channel.id] = channel.name;
    },

    parserMerchantSelectedHttpResponse(response) {
      let localMerchantData = {
        level1: {},
        level2: {},
        level3: {},
        level4: {},
        channels: {}
      };
      for (const merchantData of response.data) {
        let channel = {
          name: merchantData.name,
          agents: [
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 1),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 2),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 3),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 4)
          ]
        };

        localMerchantData.channels[merchantData.id] = channel;

        let simpleChannel = { id: merchantData.id, name: channel.name };

        // 配置商户底下的渠道
        this.setAgentChannel(
          localMerchantData.level1,
          channel.agents[0],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level2,
          channel.agents[1],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level3,
          channel.agents[2],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level4,
          channel.agents[3],
          simpleChannel
        );

        // 配置商户阶层关系的渠道
        this.setChildAgent(
          localMerchantData,
          1,
          channel.agents[0],
          channel.agents[1]
        );
        this.setChildAgent(
          localMerchantData,
          2,
          channel.agents[1],
          channel.agents[2]
        );
        this.setChildAgent(
          localMerchantData,
          3,
          channel.agents[2],
          channel.agents[3]
        );

        for (let i = channel.agents.length; i > 0; i--) {
          if (channel.agents[i - 1] != null) {
            let agent = channel.agents[i - 1];
            localMerchantData[`level${i}`][agent.id].directlyChannels[
              merchantData.id
            ] = merchantData.name;
            break;
          }
        }
      }

      return localMerchantData;
    },

    getDirectChinnel(agentLevel, directlyChannel = false) {
      let channels = [];
      let x = directlyChannel
        ? agentLevel.directlyChannels
        : agentLevel.channels;
      for (const [channelId, channelName] of Object.entries(x)) {
        channels.push({
          id: channelId.toString(),
          name: channelName
        });
      }
      return channels;
    },

    getDirectAgent(localMerchantData, level, agentId) {
      let childAgents = [];
      let childs =
        level > 0
          ? localMerchantData[`level${level}`][agentId].childs
          : localMerchantData[`level1`];
      for (const [childAgentId, childAgentName] of Object.entries(childs)) {
        childAgents.push({
          id: childAgentId.toString(),
          name: childAgentName.name || childAgentName
        });
      }
      return childAgents;
    },

    chooseLevelMerchant(
      localMerchantData,
      level,
      agentId,
      directlyChannel = false
    ) {
      let result = {
        chooseLevel1: null,
        chooseLevel2: null,
        chooseLevel3: null,
        chooseLevel4: null,
        chooseChannel: null,
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        channels: []
      };

      let chooseAgent = null;
      let currentLevel = null;

      if (level >= 5) {
        // 给定指定渠道
        let channel = localMerchantData[`channels`][agentId];
        let chooseChannel = {
          id: agentId.toString(),
          name: channel.name
        };
        result[`chooseChannel`] = chooseChannel;
        channel.agents.forEach((agent, index) => {
          if (!agent) {
            return;
          }
          level = index + 1;
          agentId = agent.id;
        });
      }

      if (level > 0 && level < 5) {
        chooseAgent = {
          id: agentId.toString(),
          name: localMerchantData[`level${level}`][agentId].name
        };

        // 给定当前等级
        result[`chooseLevel${level}`] = chooseAgent;

        currentLevel = level;
        let currentAgentId = agentId;
        // 给定父级
        while (currentLevel > 1) {
          let parentId =
            localMerchantData[`level${currentLevel}`][currentAgentId].parentId;
          let parent = {
            id: parentId.toString(),
            name: localMerchantData[`level${currentLevel - 1}`][parentId].name
          };
          result[`chooseLevel${currentLevel - 1}`] = parent;
          let currentLevelAgents = this.getDirectAgent(
            localMerchantData,
            currentLevel - 1,
            parentId
          );
          result[`level${currentLevel}`] = currentLevelAgents;

          currentLevel -= 1;
          currentAgentId = parentId;
        }
      }

      let level1Agents = this.getDirectAgent(localMerchantData, 0);

      result[`level1`] = level1Agents;

      // 给定子级跟渠道
      if (level > 0 && level < 5) {
        result.channels = result.channels.concat(
          this.getDirectChinnel(
            localMerchantData[`level${level}`][agentId],
            directlyChannel
          )
        );
      }
      currentLevel = null;
      let currentAgents = null;
      if (level == 0) {
        let currentLevelAgents = this.getDirectAgent(localMerchantData, 0);
        result[`level1`] = currentLevelAgents;

        for (const [agentId, agentLevel] of Object.entries(
          localMerchantData[`level${level + 1}`]
        )) {
          result.channels = result.channels.concat(
            this.getDirectChinnel(
              localMerchantData[`level${level + 1}`][agentId]
            )
          );
        }
        currentLevel = 1;
        currentAgents = result[`level1`];
      } else {
        currentAgents = [result[`chooseLevel${level}`]];
        currentLevel = level;
      }

      while (currentLevel < 4) {
        for (const agent of currentAgents) {
          for (const [childId, childName] of Object.entries(
            localMerchantData[`level${currentLevel}`][agent.id].childs
          )) {
            result[`level${currentLevel + 1}`].push({
              id: childId.toString(),
              name: childName
            });
          }
        }
        currentLevel += 1;
        currentAgents = result[`level${currentLevel}`];
      }
      return result;
    },
    agentChange(val) {
      this.queryData.merchantId = "";
      this.merchatList = [];
      this.partner = "";
      this.partnerSelect = [];
      this.masterDistributor = "";
      this.masterDistributorSelect = [];
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.merchatList = this.objToArray(this.merchantParserData.channels);
      this.partnerSelect = this.objToArray(this.merchantParserData.level1);
      this.masterDistributorSelect = this.objToArray(
        this.merchantParserData.level2
      );
      this.distributorSelect = this.objToArray(this.merchantParserData.level3);
      this.companySelect = this.objToArray(this.merchantParserData.level4);
    },
    formatOptionData(filterMerchantData) {
      const {
        level1,
        level2,
        level3,
        level4,
        chooseLevel1,
        chooseLevel2,
        chooseLevel3,
        chooseLevel4,
        channels
      } = filterMerchantData;
      this.partnerSelect = level1 || [];
      this.masterDistributorSelect = level2 || [];
      this.distributorSelect = level3 || [];
      this.companySelect = level4 || [];
      this.partner = chooseLevel1?.id || "";
      this.masterDistributor = chooseLevel2?.id || "";
      this.distributor = chooseLevel3?.id || "";
      this.company = chooseLevel4?.id || "";
      this.merchatList = channels;
    },
    merchantIdChange(val) {
      if (!val) {
        return;
      }
      let status = this.ChannelType == 1 ? false : true;
      let filterMerchantData = this.chooseLevelMerchant(
        this.merchantParserData,
        5,
        val,
        status
      );
      this.formatOptionData(filterMerchantData);
    },
    //level 1
    partnerChange(val) {
      this.masterDistributor = "";
      this.masterDistributorSelect = [];
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.queryData.merchantId = "";
      if (!val) {
        this.merchatList = this.objToArray(this.merchantParserData.channels);
        this.partnerSelect = this.objToArray(this.merchantParserData.level1);
        this.masterDistributorSelect = this.objToArray(
          this.merchantParserData.level2
        );
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }

      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          1,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 2
    masterDistributorChange(val) {
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.queryData.merchantId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          1,
          this.partner,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.masterDistributorSelect = this.objToArray(
          this.merchantParserData.level2
        );
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          2,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 3
    distributorChange(val) {
      this.company = "";
      this.companySelect = [];
      this.queryData.merchantId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          2,
          this.masterDistributor,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          3,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 4
    companyChange(val) {
      this.queryData.merchantId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          3,
          this.distributor,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          4,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },

    async getRiskLevel() {
      const res = await getRiskLevel();
      let data = res.data || {};
      this.levelList = this.getArray(data);
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    // 表格选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleViewEidt(num, data, title) {
      this.title = title;
      this.histroyNum = num;
      if (num === 2) {
        this.queryHistoryData.current = 1;
        this.queryHistoryData.size = 50;
        this.queryHistoryData.businessId = data.merchantId;
        this.$refs["dialogListDom"].isShowDia(this.title, true, "1300px");
        this.getHistoryList();
      } else if (num === 1) {
        this.queryForm.merchantId = [data.merchantId];
        this.queryForm.merchantName = data.merchantName;
        this.queryForm.templateId = data.templateId;
        this.queryForm.warningTemplateId = data.warningTemplateId;
        this.queryForm.promotionTemplateId = data.promotionTemplateId;
        this.queryForm.oddsLevelId = data.oddsLevelId;
        this.queryForm.newUserOddsLevelId = data.newUserOddsLevelId;
        this.queryForm.marginOddsLevelId = data.marginOddsLevelId;
        this.queryForm.newUserMarginOddsLevelId = data.newUserMarginOddsLevelId;
        this.queryForm.remark = data.remark;
        this.queryForm.bgColor = data.merchantBgColor;
        this.queryForm.fontColor = data.merchantFontColor;
        this.$refs["dialogListDom"].isShowDia(this.title, true, "500px");
      }
    },
    CloseHistory() {
      this.$refs["dialogListDom"].isShowDia(this.title, false, "1300px");
    },
    fetchHistoryLevel(val) {
      let name = "";
      this.levelListName.map(item => {
        if (item.id == val) {
          name = item.name;
        }
        if (!val) {
          name = "默认";
        }
      });
      return name;
    },
    fetchHistoryWarning(val) {
      let name = "";
      this.warningListName.map(item => {
        if (item.id == val) {
          name = item.templateName;
        }
        if (!val) {
          name = "";
        }
      });
      return name;
    },
    fetchOddsLevel(val) {
      let name = "";
      this.oddList.map(item => {
        if (item.id == val) {
          name = item.label;
        }
        if (val == -1) {
          name = "-";
        }
      });
      return name;
    },
    async getHistoryList() {
      this.loadingItem = true;
      try {
        const res = await getMerchantHistoryList(this.queryHistoryData);
        const data = res.data || {};
        this.historyList = data.records || [];       // 原始
        this.totalAert = Number(data.total || 0);
        // 新增：生成弹窗表格用的行数据
        this.historyRows = this.normalizeHistory(this.historyList);
      } catch (e) {
        this.historyList = [];
        this.historyRows = [];
      } finally {
        this.loadingItem = false;
      }
    },
    // 分页
    changeAlertPage(e) {
      this.queryHistoryData.current = e;
      this.getHistoryList();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryHistoryData.size = e;
      this.queryHistoryData.current = 1;
      this.getHistoryList();
    },
    singleClose() {
      this.$refs["dialogListDom"].isShowDia(this.title, false, "500px");
    },
    isShow(title) {
      if (this.multipleSelection.length > 0) {
        this.resetBatchForm();
        this.levelQueryData.merchantId = this.multipleSelection.map(el => el.merchantId);
        this.title = title;
        this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
      } else {
        this.$message({ message: "Must checked one", type: "warning" });
      }
    },
    // async handleBatchModify(val) {
    //   let param = "";
    //   if (val == 1) {
    //     param = { ...this.queryForm };
    //     delete param.merchantName;
    //   } else {
    //     param = { ...this.levelQueryData };
    //   }

    //   await updateMerchantTemplate(param);
    //   this.$message({ message: "update success", type: "success" });

    //   this.resetBatchForm();
    //   this.Close();
    //   this.singleClose();
    //   this.getList();
    // },
    async handleBatchModify(val) {
      let param = "";

      if (val == 1) {
        // 单个修改逻辑不变
        param = { ...this.queryForm };
        delete param.merchantName;
      } else {
        // 只针对批量修改处理默认值
        const batchForm = { ...this.levelQueryData };

        param = {
          merchantId: batchForm.merchantId || [],
          templateId: batchForm.templateId || null,
          promotionTemplateId: batchForm.promotionTemplateId || null,
          remark: batchForm.remark || null,
          bgColor: batchForm.bgColor || null,
          fontColor: batchForm.fontColor || null,

          // 这三个字段：没选就传 -1
          oddsLevelId: batchForm.oddsLevelId || null,
          newUserOddsLevelId:
            batchForm.newUserOddsLevelId === "" ||
            batchForm.newUserOddsLevelId === undefined ||
            batchForm.newUserOddsLevelId === null
              ? -1
              : batchForm.newUserOddsLevelId,

          marginOddsLevelId:
            batchForm.marginOddsLevelId === "" ||
            batchForm.marginOddsLevelId === undefined ||
            batchForm.marginOddsLevelId === null
              ? -1
              : batchForm.marginOddsLevelId,

          newUserMarginOddsLevelId:
            batchForm.newUserMarginOddsLevelId === "" ||
            batchForm.newUserMarginOddsLevelId === undefined ||
            batchForm.newUserMarginOddsLevelId === null
              ? -1
              : batchForm.newUserMarginOddsLevelId
        };
      }

      await updateMerchantTemplate(param);
      this.$message({ message: "update success", type: "success" });

      this.resetBatchForm();
      this.Close();
      this.singleClose();
      this.getList();
    },
    Close() {
      this.resetBatchForm();
      this.$refs["dialogDom"].isShowDia(this.title, false, "500px");
    },
    // 查看历史
    // handleViewHistory(data) {
    //   this.$router.push({
    //     path: "/channel/channelHistory",
    //     query: { id: data.merchantId }
    //   });
    // },
    // 清空
    handleClear() {}
  },
  components: {
    dia,
    Empty
  },
  mounted() {
    this.getLevelListName();
    this.getBonusListName();
    this.getWarningListName();
    this.getRiskLevel();
    this.fetchMerchantList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.more-search-part {
  display: flex;
  flex-direction: column;
}
.ranking-date,
.export-wrapper {
  font-size: 12px;
  margin: 10px 0;
  .header-tab {
    display: flex;
    align-items: center;
    height: 32px;
    width: 150px;
    margin-right: 10px;
    span {
      width: 100px;
      text-align: center;
      cursor: pointer;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      &.active {
        color: #fff;
        background: #00a791;
        border: 1px solid #00a791;
      }
      &:hover {
        opacity: 0.7;
      }
    }
    .fisrt-box {
      border-radius: 4px 0 0 4px;
    }
    .two-box {
      border-radius: 0 4px 4px 0;
    }
  }
}
.middle-btn {
  margin: 0 0 10px 0;
}
.label-btn {
  border: 1px solid #dcdfe6;
  width: 102px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-amount-wrapper {
  text-align: center;
  background-color: #fff;
  border-radius: 16px;
  .time-range-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .time-range {
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 100px;
      display: flex;
      border: 1px solid #ebedf3;
      p {
        color: #414b5f !important;
        font-weight: normal;
        font-size: 13px;
        padding: 7px 35px;
        margin-left: 0;
        border-right: 1px solid #ebedf3;

        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          border-right: 0;
          border-radius: 0 100px 100px 0;
        }
        &:first-child {
          border-radius: 100px 0px 0px 100px;
        }
        &.active {
          color: #fff !important;
          background: #00a791;
          border: 1px solid #00a791;
        }
      }
    }
  }
}
#orderAmount {
  height: 378px;
}
.icona-Property1baocun {
  font-size: 12px;
}

.iconqushi {
  font-size: 16px;
  color: #0184b8;
}
.el-range-editor--small.el-input__inner {
  width: 260px;
}
/deep/.el-input-group__append {
  padding: 0 5px !important;
}
/deep/.level-box {
  .el-select {
    .el-input {
      width: 200px;
    }
  }
}
/deep/.select-down-wrapper {
  .el-select {
    width: 100%;
  }
}
.config-btn {
  width: 136px;
}
</style>
